// removed by extract-text-webpack-plugin
module.exports = {"legendSection":"legendSection_rjJ","legendHeading":"legendHeading_2t7","legendRow":"legendRow_3Yo","legendText":"legendText_2vD","legendImg":"legendImg_CaM","legendCircle":"legendCircle_HFv","legendCircleGreen":"legendCircleGreen_2iz","legendCircleBlue":"legendCircleBlue_2Yw","legendCircleLightBlue":"legendCircleLightBlue_38y","legendCircleStriped":"legendCircleStriped_BuM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/legend/legend.scss
// module id = 393
// module chunks = 0 1